import { INITIAL_APPLICATION, INITIAL_QUICK_QUOTE } from '@/utils/constants';

export default function () {
  return {
    application: { ...INITIAL_APPLICATION },
    quickQuote: { ...INITIAL_QUICK_QUOTE },
    guardingNavigation: false,
    applicationLoading: false,
    applicationSaving: false,
    financeLoading: false,
    savingQuoteFile: false,
    gettingQuoteFile: false,
    sendingHRApproval: false,
    clearingApplication: false,
    savingForExit: false,
    leaseId: null
  };
}
